import React from 'react';
import { EmptyState } from '../shared/ui';

const NotFoundPage: React.FC = () => {
  return <EmptyState type="not-found" />;
};

export default NotFoundPage;
